import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import {
  handleDataCreditScore,
  handleDataPerformanceScore,
  handlePortfolio,
} from '../helper'
import {
  getCreditRiskScore,
  getPerformanceScore,
  getSavedPortfolio,
} from './thunk'

const initialState = {
  loading: {
    getPortfolio: true,
    creditRiskScore: true,
    performanceScore: true,
  },
  portfolio: {
    data: [],
    activePortfolio: {},
  },
  creditRiskScore: {
    data: [],
  },
  performanceScore: {
    data: [],
  },
}

const slice = createSlice({
  name: 'dashboard/yourPortfolio',
  initialState,
  reducers: {
    changeActivePortfolio: (state, action) => {
      state.portfolio.activePortfolio = action.payload
    },
  },
  extraReducers: (builder) => {
    //getSavedPortfolio
    builder.addCase(getSavedPortfolio.pending, (state, action) => {
      state.loading.getPortfolio = true
    })
    builder.addCase(getSavedPortfolio.fulfilled, (state, action) => {
      state.portfolio.data = handlePortfolio(action.payload)
      state.portfolio.activePortfolio = handlePortfolio(action.payload)[0]
      state.loading.getPortfolio = false
    })
    builder.addCase(getSavedPortfolio.rejected, (state, action) => {
      state.portfolio = initialState.portfolio
      state.loading.getPortfolio = action.payload.loading
    })
    //getCreditRiskScore
    builder.addCase(getCreditRiskScore.pending, (state, action) => {
      state.loading.creditRiskScore = true
    })
    builder.addCase(getCreditRiskScore.fulfilled, (state, action) => {
      state.creditRiskScore.data = handleDataCreditScore(action.payload)
      state.loading.creditRiskScore = false
    })
    builder.addCase(getCreditRiskScore.rejected, (state, action) => {
      state.creditRiskScore = initialState.creditRiskScore
      state.loading.creditRiskScore = action.payload.loading
    })
    //getPerformanceScore
    builder.addCase(getPerformanceScore.pending, (state, action) => {
      state.loading.performanceScore = true
    })
    builder.addCase(getPerformanceScore.fulfilled, (state, action) => {
      state.performanceScore.data = handleDataPerformanceScore(action.payload)
      state.loading.performanceScore = false
    })
    builder.addCase(getPerformanceScore.rejected, (state, action) => {
      state.performanceScore = initialState.performanceScore
      state.loading.performanceScore = action.payload.loading
    })
  },
})

//loading
export const loadingYourPortfolio = (type) => (state) =>
  state[slice.name].loading[type]
//get Portfolio
export const selectPortfolio = (type) => (state) =>
  state[slice.name].portfolio[type]
//get Credit Risk Score
export const selectCreditRiskScore = (type) => (state) =>
  state[slice.name].creditRiskScore[type]
//get Performance Score
export const selectPerformanceScore = (type) => (state) =>
  state[slice.name].performanceScore[type]

export const { changeActivePortfolio } = slice.actions

register(slice.name, slice.reducer)
